import { getOccupancyText } from 'components/Recommendations/utils/getOccupancyText'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { createSelector } from 'reselect'

import { formatDynamicDateRange } from 'lib/datetime/dateUtils'
import { DAY_FORMAT, DAY_MONTH_NAME_SHORT, DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'

export const getCurrentOccupancyLabel = createSelector(
  (offerPageState: OfferPageState) => offerPageState.offer! || offerPageState.bedbankOffer!,
  (offerPageState: OfferPageState) => offerPageState.rooms,
  (offer, rooms) => {
    const roomOccupants = rooms || [generateRoomOccupants()]
    return getOccupancyText(roomOccupants, offer.saleUnit)
  },
)

export const getCurrentDateLabel = createSelector(
  (offerPageState: OfferPageState) => offerPageState.checkInDate,
  (offerPageState: OfferPageState) => offerPageState.checkOutDate,
  (offerPageState: OfferPageState) => offerPageState.duration,
  (checkIn, checkOut, duration) => {
    return formatDynamicDateRange(checkIn, checkOut, duration)
  },
)

export const getDatesOccupancyLabel = createSelector(
  getCurrentDateLabel,
  getCurrentOccupancyLabel,
  (dateLabel, occupancyLabel) => {
    return `${dateLabel}, ${occupancyLabel}`
  },
)

export const getStickyFooterDatesLabel = (checkIn: moment.Moment, checkOut: moment.Moment) => {
  if (checkIn.isSame(checkOut, 'month')) {
    return `${checkIn.format(DAY_FORMAT)} - ${checkOut.format(DAY_MONTH_NAME_SHORT)}`
  } else if (checkIn.isSame(checkOut, 'year')) {
    return `${checkIn.format(DAY_MONTH_NAME_SHORT)} - ${checkOut.format(DAY_MONTH_NAME_SHORT)}`
  }

  return `${checkIn.format(DMY_CASUAL_SHORT_FORMAT)} - ${checkOut.format(DMY_CASUAL_SHORT_FORMAT)}`
}
